export default "__VITE_ASSET__6gvl0QmR__"